import { TeamChatState } from '@/redux/types/teamChat'

export const initialTeamChatState: TeamChatState = {
  isConnected: false,
  error: null,
  messages: [],
  isLoading: false,
  pagination: null,
  loadingMoreMessages: false,
  unreadCount: 0,
}

export type { TeamChatMessage } from '@/redux/types/teamChat'
